import * as React from 'react';
import type { SVGProps } from 'react';
const SvgFlattenPdf = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <rect width={24} height={24} fill="#FF678C" rx={5} />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m5.333 12 6.428 3.233c.088.044.132.066.178.075a.3.3 0 0 0 .122 0 .7.7 0 0 0 .177-.075L18.667 12M5.333 15.353l6.428 3.233c.088.044.132.066.178.075a.3.3 0 0 0 .122 0c.046-.009.09-.03.177-.075l6.429-3.233M5.333 8.647l6.428-3.233c.088-.044.132-.066.178-.075a.3.3 0 0 1 .122 0c.046.009.09.03.177.075l6.429 3.233-6.429 3.233c-.087.044-.13.066-.177.075a.3.3 0 0 1-.123 0c-.045-.01-.09-.031-.177-.075z"
    />
  </svg>
);
export default SvgFlattenPdf;
